module.exports = __webpack_public_path__ + "img/Login-crousal-3.a2b3ce49.svg";